import { render } from "./editData.vue?vue&type=template&id=e42f088a&scoped=true"
import script from "./editData.vue?vue&type=script&lang=ts"
export * from "./editData.vue?vue&type=script&lang=ts"

import "./editData.vue?vue&type=style&index=0&id=e42f088a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e42f088a"

export default script